var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.term == -1
      ? _c(
          "div",
          [
            _c("layout-1", {
              staticStyle: { width: "100%", height: "calc(100vh - 50px)" },
              attrs: {
                table_name: _vm.tableName,
                id: _vm.pageid1,
                searchbar: false,
                navbar: false,
                button_perm: "20",
                button_name: "Select",
                term: [-1, _vm.statusGroup],
                termchange: true
              },
              on: { select: _vm.select }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("layout-1", {
              staticStyle: { width: "100%", height: "calc(100vh - 85px)" },
              attrs: {
                table_name: _vm.tableName,
                id: _vm.pageid1,
                searchbar: true,
                use_limit: false,
                separateSearch: true,
                navbar: false,
                term: [_vm.searchTerm, _vm.statusGroup],
                termchange: true,
                useStatusSearch: true,
                button_perm: "20",
                button_name: "Select",
                reroute: "/0601",
                select_reroute: true
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "nav-bar",
                on: {
                  click: function($event) {
                    return _vm.cancel()
                  }
                }
              },
              [_vm._v("Cancel")]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74b85248", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b85248","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Status.vue
// module id = 742
// module chunks = 0